import { render, staticRenderFns } from "./topheader.vue?vue&type=template&id=83fb89e6"
import script from "./topheader.vue?vue&type=script&lang=js"
export * from "./topheader.vue?vue&type=script&lang=js"
import style0 from "./topheader.vue?vue&type=style&index=0&id=83fb89e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports